import { marketingMenuKeyForPage, marketingPageForKey } from "./marketing-navigation";

type NavigationItem = { key: string; label: string; children?: NavigationItem[] };

const internalPages: Record<string, { key: string; label: string }> = {
  accountSecurity: { key: "", label: "账号与登录设备" },
  projectServices: { key: "projectManagement", label: "服务项目" },
  projectPackages: { key: "projectManagement", label: "服务套餐" },
  projectProducts: { key: "projectManagement", label: "商品管理" },
  homeServiceOnboarding: { key: "serviceStaffManagement", label: "入职登记" },
  agencyOnboarding: { key: "agencyHousekeepers", label: "入职登记" },
  attendance: { key: "leaveApproval", label: "打卡明细" },
  agencyMatches: { key: "agencyHousekeepers", label: "匹配工作台" },
  recruitmentOnboarding: { key: "", label: "招聘与入职" },
  addHousekeeper: { key: "agencyHousekeepers", label: "新增家政员" },
  editHousekeeper: { key: "agencyHousekeepers", label: "编辑家政员" },
  completeHousekeeper: { key: "agencyHousekeepers", label: "完善家政员档案" },
};

function menuPath(items: NavigationItem[], key: string): NavigationItem[] {
  for (const item of items) {
    if (item.key === key) return [item];
    const path = item.children ? menuPath(item.children, key) : [];
    if (path.length) return [item, ...path];
  }
  return [];
}

/** Section labels follow the filtered menu without exposing hidden navigation. */
export function navigationLocation(items: NavigationItem[], page: string) {
  const basePage = page.split(":")[0];
  const internal = internalPages[basePage];
  const path = menuPath(items, internal?.key ?? marketingMenuKeyForPage(basePage));
  return {
    section: path.length > 1 ? path[0].label : "",
    title: internal?.label ?? marketingPageForKey(basePage)?.title ?? path.at(-1)?.label ?? "管理后台",
  };
}
